import React from "react";
import "./developer-parallax.scss";
import Marquee from "react-fast-marquee";
import {useNavigate} from "react-router-dom";


function DeveloperParallax() {
    const developers: string[] = [
        "AYS",
        "Aldar",
        "Arada",
        "Avelon",
        "Azizi",
        "Binghatti",
        "Damac",
        "Danube",
        "Dubai Properties",
        "Ellington",
        "Emaar",
        "Meraas",
        "Nakheel",
        "Octa",
        "Omniyat",
        "Samana",
        "Sobha",
        "Vincitore",
        "Wasal",
        "iMAN",
        "taraf",
    ];

    const navigate = useNavigate();

    const navigateToURL = (url: string) => {
        navigate(`/${url}`);
    }

    return (
        <div className={"developer-parallax"}>
            <div className={"developer-parallax-overlay"}>
                <h3 className={"heading"}>MEET OUR DEVELOPERS</h3>

                <div className={"developer-marquee"}>
                    <Marquee speed={25} autoFill={true} className={"marquee"}>
                        <div className={"marquee-container"}>
                            {
                                developers.map((name: string) => (
                                    <div className={"marquee-item"}>
                                        <span className={"marquee-item-logo"}>
                                            <img src={"/Samples/developer_logos/"+name+".png"} alt="" />
                                        </span>
                                        {/* <span className={"marquee-item-name"}>{name.toUpperCase()}</span> */}
                                    </div>

                                ))
                            }
                        </div>
                    </Marquee>
                </div>

                <div className={"more-developers"}>
                    <button className={"more-developers-btn"} onClick={() => navigateToURL("developer/list")}>MORE DEVELOPERS</button>
                </div>
            </div>
        </div>
    )
}



// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay } from "swiper/modules";
// import "swiper/css";
// import "./StockTicker.css"; // Add custom styles

// const stocks = [
//   { name: "AAPL", price: "$145.23", change: "+1.45%" },
//   { name: "TSLA", price: "$790.12", change: "-0.72%" },
//   { name: "GOOGL", price: "$2783.98", change: "+2.30%" },
//   { name: "MSFT", price: "$305.22", change: "-1.12%" },
// ];

// const StockTickerSwiper = () => {
//   return (
//     <div className="stock-ticker">
//       <Swiper
//         modules={[Autoplay]}
//         spaceBetween={30}
//         slidesPerView={"auto"} // ✅ Allows free-flowing scrolling
//         loop={true} // ✅ Infinite scrolling
//         speed={3000} // ✅ Smooth scrolling speed
//         autoplay={{
//           delay: 0,
//           disableOnInteraction: false,
//           pauseOnMouseEnter: false,
//         }}
//         freeMode={true} // ✅ Removes snap effect for smooth scrolling
//         className="stock-swiper"
//       >
//         {stocks.map((stock, index) => (
//           <SwiperSlide key={index} className="stock-slide">
//             <span>{stock.name}</span> <strong>{stock.price}</strong> <span>{stock.change}</span>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </div>
//   );
// };

// export default StockTickerSwiper;

export default DeveloperParallax;